/* One click-open vehicle selector shared by header and product entry points. */
(() => {
  if (customElements.get('jss-vehicle-panel')) return;
  class VehiclePanel extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.finder = this.querySelector('js-diesel-finder');
      this.querySelector('[data-panel-close]').addEventListener('click', () => this.close(), opts);
      this.querySelector('[data-panel-results]').addEventListener('click', () => {
        if (this.finder.submit.disabled || !this.finder.form.reportValidity()) return;
        this.showResults = true;
        this.finder.form.requestSubmit();
      }, opts);
      this.addEventListener('jss:vehicle-saved', () => {
        if (this.showResults) {
          const url = window.JSDieselFitment.urlFor(this.finder.dataset.collectionUrl, location.href, this.finder.selection, 'applications');
          this.finder.navigate(url);
        } else this.close();
      }, opts);
      document.addEventListener('keydown', event => {
        if (!this.hidden && event.key === 'Escape') { event.preventDefault(); this.close(); }
      }, opts);
      document.addEventListener('click', event => {
        if (!this.hidden && !this.contains(event.target) && !this.trigger?.contains(event.target)) this.close(false);
      }, opts);
      document.addEventListener('toggle', event => {
        if (!this.hidden && event.target.matches?.('.jss-mega__disclosure[open]')) this.close(false);
      }, { ...opts, capture: true });
      window.addEventListener('resize', () => this.position(), opts);
      window.addEventListener('scroll', () => this.position(), { ...opts, passive: true });
      this.observer = new ResizeObserver(() => this.position());
      const header = document.querySelector('.jss-header');
      if (header) this.observer.observe(header);
      this.formObserver = new MutationObserver(() => {
        this.querySelector('[data-panel-results]').disabled = this.finder.submit?.disabled !== false;
      });
      this.formObserver.observe(this.finder, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
    open(trigger, productCheck = null) {
      if (!this.hidden && this.trigger === trigger) { this.close(); return; }
      document.querySelectorAll('jss-mega-menu').forEach(menu => menu.close?.());
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.trigger = trigger;
      trigger?.setAttribute('aria-controls', this.id);
      trigger?.setAttribute('aria-expanded', 'true');
      this.showResults = false;
      this.querySelector('[data-panel-intro]').textContent = productCheck
        ? 'Select your vehicle to check fitment for the selected product option.'
        : 'Search parts for diesel trucks, SUVs and Sprinter vans by vehicle.';
      this.finder.submit.firstChild.textContent = productCheck ? 'Save & check fitment ' : 'Save vehicle ';
      this.finder.querySelector('[data-jsdf-optional]').open = false;
      this.finder.querySelector('[data-jsdf-optional]').hidden = false;
      const record = window.JSSVehicle.get();
      const source = productCheck && [...document.querySelectorAll('jss-product-fitment')].find(el => el.dataset.productId === productCheck.dataset.productId);
      // Keep saved values visible while the verified options are refreshed.
      for (const [key, field] of Object.entries(this.finder.fields)) {
        const value = record?.values[key] || '';
        field.replaceChildren(new Option(value || (key === 'engine' ? 'Select engine size' : 'Select ' + key), value));
        field.value = value;
      }
      this.hidden = false;
      this.syncHeaderState(true);
      this.position();
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.animation?.cancel();
        this.animation = this.animate([{ opacity: 0, transform: 'translateY(-12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
      }
      this.finder.setVehicle(record?.values || {}, source?.currentState?.data?.applications || []);
      this.querySelector('[data-panel-close]').focus({ preventScroll: true });
    }
    position() {
      if (this.hidden) return;
      const header = document.querySelector('.jss-header');
      const bounds = header?.getBoundingClientRect();
      const top = Math.max(0, Math.min(bounds?.bottom || 0, innerHeight - 160));
      const container = header?.querySelector('.jss-header__container')?.getBoundingClientRect();
      this.style.top = top + 'px';
      this.style.maxHeight = Math.max(160, innerHeight - top - 12) + 'px';
      this.style.width = Math.min(container?.width || 1280, innerWidth - 24) + 'px';
    }
    syncHeaderState(open) {
      document.querySelectorAll('[data-header-vehicle-link]').forEach(link => link.setAttribute('aria-expanded', String(open)));
    }
    close(restoreFocus = true) {
      this.animation?.cancel();
      this.hidden = true;
      this.syncHeaderState(false);
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.trigger?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.syncHeaderState(false);
      this.events?.abort(); this.events = null;
      this.observer?.disconnect(); this.formObserver?.disconnect(); this.animation?.cancel();
    }
  }
  customElements.define('jss-vehicle-panel', VehiclePanel);
})();
